import getCurrentCategory from './getCurrentCategory';
import { getStore } from '../store/store';
import { computed, IComputedValue } from 'mobx';
import { OptionSubCategory } from 'owa-options-core';

let currentSubcategory = computed(() => {
    let currentCategory = getCurrentCategory();

    for (
        let subcategoryIndex = 0;
        currentCategory && subcategoryIndex < currentCategory.subcategories.length;
        subcategoryIndex++
    ) {
        let currentSubcategory = currentCategory.subcategories[subcategoryIndex];

        if (currentSubcategory.key === getStore().currentSubCategoryKey) {
            return currentSubcategory;
        }
    }

    return {};
}) as IComputedValue<OptionSubCategory>;

export default () => currentSubcategory.get();
